// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1nJFI","rootMobile":"styles_rootMobile__2CPav"};